import { type TableHeaderRow } from '@shared/table-generator';

export const headersWithStatuses: TableHeaderRow[] = [
  {
    children: [
      { id: 'seatNumber', children: 'เลขที่นั่ง', width: 78, align: 'center', rowSpan: 2 },
      { id: 'name', children: 'ชื่อ-นามสกุล', width: 240, rowSpan: 2 },
      { id: 'idNumber', children: 'ID / Passport No.', width: 180, rowSpan: 2 },
      { id: 'email', children: 'Email', width: 240, rowSpan: 2 },
      { id: 'ekycStatus', children: 'e-KYC', width: 100, rowSpan: 2 },
      { id: 'isExamReady', children: 'ชุดข้อสอบ', width: 100, rowSpan: 2 },
      { id: 'course', children: 'หลักสูตร', width: 120, rowSpan: 2 },
      { id: 'status', children: 'สถานะผู้เข้าสอบ', width: 140, rowSpan: 2 },
      { id: 'remark', children: 'Remark', width: 160, rowSpan: 2 },
      {
        id: 'realtimeStatus',
        children: 'สถานะผู้เข้าสอบ Real-Time',
        width: 480,
        colSpan: 4,
        align: 'center',
      },
      {
        id: 'examEndedAt',
        align: 'center',
        children: 'หมดเวลาสอบ',
        width: 120,
        rowSpan: 2,
      },
      {
        id: 'result',
        children: 'Result',
        width: 100,
        rowSpan: 2,
      },
      {
        id: 'certificate',
        children: 'Certificate',
        width: 100,
        rowSpan: 2,
      },
      {
        id: 'sentToSETPortalAt',
        width: 182,
        rowSpan: 2,
        children: 'วันที่ส่งผล (SET Portal)',
      },
      {
        id: 'action',
        width: 48,
        rowSpan: 2,
      },
    ],
  },
  {
    children: [
      { id: 'realtimeStatus.loginStatus', children: 'เข้าสู่ระบบ', align: 'center' },
      { id: 'realtimeStatus.examStatus', children: 'เข้าทำข้อสอบ', align: 'center' },
      { id: 'realtimeStatus.examSubmitStatus', children: 'ส่งข้อสอบ', align: 'center' },
      { id: 'realtimeStatus.questionnaireStatus', children: 'แบบสอบถาม', align: 'center' },
    ],
  },
];

export const headersWithoutStatuses: TableHeaderRow[] = [
  {
    children: [
      { id: 'seatNumber', children: 'เลขที่นั่ง', width: 78, align: 'center', rowSpan: 2 },
      { id: 'name', children: 'ชื่อ-นามสกุล', width: 240, rowSpan: 2 },
      { id: 'idNumber', children: 'ID / Passport No.', width: 180, rowSpan: 2 },
      { id: 'email', children: 'Email', width: 240, rowSpan: 2 },
      { id: 'ekycStatus', children: 'e-KYC', width: 100, rowSpan: 2 },
      { id: 'isExamReady', children: 'ชุดข้อสอบ', width: 100, rowSpan: 2 },
      { id: 'course', children: 'หลักสูตร', width: 120, rowSpan: 2 },
      { id: 'status', children: 'สถานะผู้เข้าสอบ', width: 140, rowSpan: 2 },
      { id: 'remark', children: 'Remark', width: 160, rowSpan: 2 },
      {
        id: 'result',
        children: 'Result',
        width: 100,
        rowSpan: 2,
      },
      {
        id: 'certificate',
        children: 'Certificate',
        width: 100,
        rowSpan: 2,
      },
      {
        id: 'sentToSETPortalAt',
        width: 182,
        rowSpan: 2,
        children: 'วันที่ส่งผล (SET Portal)',
      },
      {
        id: 'action',
        width: 48,
        rowSpan: 2,
      },
    ],
  },
];

export const headersWithoutStatusesAndExamStatus: TableHeaderRow[] = [
  {
    children: [
      { id: 'seatNumber', children: 'เลขที่นั่ง', width: 78, align: 'center', rowSpan: 2 },
      { id: 'name', children: 'ชื่อ-นามสกุล', width: 240, rowSpan: 2 },
      { id: 'idNumber', children: 'ID / Passport No.', width: 180, rowSpan: 2 },
      { id: 'email', children: 'Email', width: 240, rowSpan: 2 },
      { id: 'ekycStatus', children: 'e-KYC', width: 100, rowSpan: 2 },
      { id: 'course', children: 'หลักสูตร', width: 120, rowSpan: 2 },
      { id: 'status', children: 'สถานะผู้เข้าสอบ', width: 140, rowSpan: 2 },
      { id: 'remark', children: 'Remark', width: 160, rowSpan: 2 },
      {
        id: 'result',
        children: 'Result',
        width: 100,
        rowSpan: 2,
      },
      {
        id: 'certificate',
        children: 'Certificate',
        width: 100,
        rowSpan: 2,
      },
      {
        id: 'sentToSETPortalAt',
        width: 182,
        rowSpan: 2,
        children: 'วันที่ส่งผล (SET Portal)',
      },
      {
        id: 'action',
        width: 48,
        rowSpan: 2,
      },
    ],
  },
];

export const headersWithStatusesForSession: TableHeaderRow[] = [
  {
    children: [
      { id: 'seatNumber', children: 'เลขที่นั่ง', width: 78, align: 'center', rowSpan: 2 },
      { id: 'name', children: 'ชื่อ-นามสกุล', width: 214, rowSpan: 2 },
      { id: 'idNumber', children: 'ID / Passport No.', width: 214, rowSpan: 2 },
      { id: 'course', children: 'หลักสูตร', width: 120, rowSpan: 2 },
      { id: 'status', children: 'สถานะผู้เข้าสอบ', width: 143, rowSpan: 2 },
      {
        id: 'realtimeStatus',
        children: 'สถานะผู้เข้าสอบ Real-Time',
        width: 480,
        colSpan: 4,
        align: 'center',
      },
      {
        id: 'examEndedAt',
        align: 'center',
        children: 'หมดเวลาสอบ',
        width: 120,
        rowSpan: 2,
      },
      {
        id: 'action',
        width: 48,
        rowSpan: 2,
      },
    ],
  },
  {
    children: [
      { id: 'realtimeStatus.loginStatus', children: 'เข้าสู่ระบบ', align: 'center' },
      { id: 'realtimeStatus.examStatus', children: 'เข้าทำข้อสอบ', align: 'center' },
      { id: 'realtimeStatus.examSubmitStatus', children: 'ส่งข้อสอบ', align: 'center' },
      { id: 'realtimeStatus.questionnaireStatus', children: 'แบบสอบถาม', align: 'center' },
    ],
  },
];
